@if (user) {
  <div class="user-menu-container">
    <button type="button" class="user-btn" [matMenuTriggerFor]="menu"
      [attr.aria-label]="user.name ? 'Menú de usuario de ' + user.name : 'Menú de usuario'">
      @if (user.picture) {
        <span class="avatar" [style.background]="'url(' + user.picture + ')'"></span>
      }
      @if (!user.picture) {
        <span class="avatar" [style.background]="'url(' + imgSvc.getImage('') + ')'"></span>
      }
    </button>
    <mat-menu #menu="matMenu" class="details-popover mt-3">
      <mat-card appearance="outlined">
        <div class="popover-header">
          <div class="nickname">{{ user!.name }}
            <div class="user-mail mt-1">{{ user!.email }}</div>
          </div>
        </div>
        <mat-card-content class="m-0">
          <mat-divider></mat-divider>
          <button mat-menu-item type="button" class="logout-button" (click)="logout()">
            <span class="logout">Cerrar Sesión</span>
          </button>
        </mat-card-content>
      </mat-card>
      </mat-menu>
    </div>
  }
